import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#06110e",
  },
  header: {
    height: 62,
    paddingHorizontal: 14,
    flexDirection: "row",
    alignItems: "center",
  },
  brand: {
    width: 180,
    flexDirection: "row",
    alignItems: "center",
  },
  brandMark: {
    width: 30,
    height: 30,
    borderRadius: 8,
    backgroundColor: "#0d211b",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 8,
  },
  brandText: {
    color: "white",
    fontSize: 20,
    fontWeight: "800",
  },
  headerActions: {
    position: "absolute",
    right: 14,
    width: 102,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerAction: {
    width: 32,
    height: 38,
    alignItems: "center",
    justifyContent: "center",
  },
  searchRow: {
    height: 42,
    marginHorizontal: 14,
    marginBottom: 10,
    paddingHorizontal: 12,
    borderRadius: 10,
    backgroundColor: "#0b211a",
    flexDirection: "row",
    alignItems: "center",
  },
  searchInput: {
    flex: 1,
    color: "white",
    fontSize: 15,
    paddingHorizontal: 10,
    paddingVertical: 0,
  },
  banner: {
    marginHorizontal: 14,
    marginBottom: 10,
    paddingHorizontal: 12,
    paddingVertical: 9,
    borderRadius: 10,
    backgroundColor: "#0d211b",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  bannerText: {
    color: "#f1f1f1",
    fontSize: 14,
    fontWeight: "600",
  },
  categoryScroller: {
    flexGrow: 0,
    flexShrink: 0,
    height: 52,
  },
  categoryList: {
    paddingHorizontal: 14,
    paddingBottom: 14,
    alignItems: "center",
  },
  compassChip: {
    width: 44,
    height: 38,
    borderRadius: 8,
    backgroundColor: "#0d211b",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
  },
  categoryChip: {
    height: 38,
    paddingHorizontal: 16,
    borderRadius: 9,
    backgroundColor: "#0b1b16",
    borderWidth: 1,
    borderColor: "#285848",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
  },
  categoryActive: {
    backgroundColor: "#159268",
  },
  categoryText: {
    color: "white",
    fontSize: 15,
    fontWeight: "700",
  },
  categoryTextActive: {
    color: "#f2f5f4",
  },
  grid: {
    flexGrow: 1,
    paddingHorizontal: 12,
    paddingBottom: 24,
  },
  videoList: {
    flex: 1,
  },
  row: {
    justifyContent: "space-between",
  },
  card: {
    width: "48.5%",
    marginBottom: 20,
  },
  thumbnailWrap: {
    width: "100%",
    aspectRatio: 16 / 9,
    borderRadius: 2,
    overflow: "hidden",
    backgroundColor: "#06110e",
  },
  thumbnail: {
    width: "100%",
    height: "100%",
  },
  duration: {
    position: "absolute",
    right: 5,
    bottom: 5,
    minWidth: 42,
    paddingHorizontal: 5,
    paddingVertical: 2,
    borderRadius: 4,
    overflow: "hidden",
    color: "white",
    backgroundColor: "rgba(0,0,0,0.72)",
    fontSize: 12,
    fontWeight: "700",
    textAlign: "center",
  },
  cardBody: {
    marginTop: 6,
    flexDirection: "row",
    alignItems: "flex-start",
  },
  title: {
    flex: 1,
    color: "white",
    fontSize: 13,
    lineHeight: 17,
    fontWeight: "400",
    marginRight: 4,
  },
  meta: {
    marginTop: 2,
    color: "#a8a8a8",
    fontSize: 11,
    lineHeight: 15,
  },
  empty: {
    flex: 1,
    minHeight: 280,
    alignItems: "center",
    justifyContent: "center",
  },
  emptyText: {
    color: "#a8a8a8",
    fontSize: 15,
    fontWeight: "600",
  },
});

export default styles;
